export default __webpack_public_path__ + "static/media/AHCBackground.94401d22.svg";